import { Component, Input } from '@angular/core';
import { FbrReceiptItem } from 'common/services/fbr-receipt.util';

/**
 * FBR Digital Invoicing block for a receipt: logo and QR side by side, then
 * one `FBR-InvoiceID:` line per id. Renders nothing when there are no items.
 * Markup mirrors fbrReceiptBlockHtml (the window.open string path).
 */
@Component({
  selector: 'app-fbr-receipt-block',
  templateUrl: './fbr-receipt-block.component.html',
})
export class FbrReceiptBlockComponent {
  @Input() items: FbrReceiptItem[] = [];
  @Input() logoUrl = '';
  /** Outer spacing differs per receipt template. */
  @Input() topSpacing = '6px';
}
